<template>
  <model-table
    :data="items"
    :noItemLabel="$t('compCarbonFormsBuildingsTable.no-building')"
    :module="module"
    :disabled="isSubmitted"
    :singleUpdateDisabled="false"
    :bulkOpsDisabled="false"
    :withTags="authStore.isAuthenticated"
    @update="$emit('update')"
    @edit="(item) => $emit('edit', item)"
    @del="(items) => $emit('del', items)"
  >
    <b-table-column :label="$t('id')" field="name" sortable v-slot="props">
      <p v-if="!props.row.name" class="warning">?</p>
      <p v-else>
        {{ props.row.name }}
      </p>
    </b-table-column>
    <b-table-column
      :label="$t('compCarbonFormsBuildingsTable.useful-area')"
      field="area"
      sortable
      :custom-sort="sortArea"
      numeric
      v-slot="props"
    >
      <p v-if="!props.row.area" class="warning">? m2</p>
      <p v-else>{{ props.row.area }} m2</p>
    </b-table-column>
    <b-table-column
      :label="$t('electricity')"
      field="electricity"
      sortable
      :custom-sort="sortElec"
      numeric
      v-slot="props"
    >
      <p :class="type(props.row.getElectricityConsumption())">
        {{ Math.round(props.row.getElectricityConsumption()) | splitNumber }}
      </p>
    </b-table-column>
    <b-table-column
      :label="$t('heatings')"
      field="heatings"
      sortable
      :custom-sort="sortHeating"
      numeric
      v-slot="props"
    >
      <b-icon
        v-if="isElectric(props.row) && !props.row.getTotalHeatingConsumption()"
        icon="plug"
      />
      <p v-else :class="type(props.row.getTotalHeatingConsumption())">
        {{ props.row.getTotalHeatingConsumption() | splitNumber }}
      </p>
    </b-table-column>
    <b-table-column
      :label="$t('refrigerants')"
      field="refrigerants"
      numeric
      v-slot="props"
    >
      {{ props.row | getGasList }}
    </b-table-column>
    <b-table-column
      :label="$t('water')"
      field="water"
      sortable
      :custom-sort="sortWater"
      numeric
      v-slot="props"
    >
      <p :class="type(props.row.getWaterConsumption())">
        {{ Math.round(props.row.getWaterConsumption()) | splitNumber }}
      </p>
    </b-table-column>
  </model-table>
</template>

<script>
import Modules from '@/models/Modules.js'
import { useAdminStore } from '@/stores/admin.js'
import { useAuthenticationStore } from '@/stores/authentication.js'
import { useGHGIStore } from '@/stores/ghgi.js'

export default {
  name: 'BuildingTable',
  setup () {
    const adminStore = useAdminStore()
    const authStore = useAuthenticationStore()
    const ghgiStore = useGHGIStore()
    return { adminStore, authStore, ghgiStore }
  },
  props: {
    items: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {
    'model-table': () => import('@/components/carbon/forms/ModelTable.vue')
  },
  computed: {
    module: function () {
      return Modules.BUILDINGS
    },
    isSubmitted: function () {
      return this.ghgiStore.item.isSubmitted
    }
  },
  filters: {
    getGasList: function (building) {
      let gasList = ''
      for (let gas of building.refrigerants) {
        gasList += gas.name.toUpperCase() + ' (' + gas.total + ' kg), '
      }
      if (gasList !== '') {
        gasList = gasList.substring(0, gasList.length - 2)
      } else {
        gasList = '0'
      }
      return gasList
    }
  },
  methods: {
    isElectric: function (building) {
      return building.heatings.map((obj) => obj.type).includes('electric')
    },
    type: function (value) {
      const number = parseFloat(value)
      if (number === 0) {
        return 'warning'
      } else {
        return null
      }
    },
    sortStr (a, b, isAsc) {
      if (isAsc) {
        return a.localeCompare(b)
      } else {
        return b.localeCompare(a)
      }
    },
    sortStrToNum (a, b, isAsc) {
      if (isAsc) {
        return Number(a) - Number(b)
      } else {
        return Number(b) - Number(a)
      }
    },
    sortEnergyClass (a, b, isAsc) {
      return this.sortStr(
        a.getEnergeticValues()[0],
        b.getEnergeticValues()[0],
        isAsc
      )
    },
    sortArea (a, b, isAsc) {
      return this.sortStrToNum(a.area, b.area, isAsc)
    },
    sortShare (a, b, isAsc) {
      return this.sortStrToNum(a.share, b.share, isAsc)
    },
    sortElec (a, b, isAsc) {
      return this.sortStrToNum(
        a.getElectricityConsumption(),
        b.getElectricityConsumption(),
        isAsc
      )
    },
    sortWater (a, b, isAsc) {
      return this.sortStrToNum(
        a.getWaterConsumption(),
        b.getWaterConsumption(),
        isAsc
      )
    },
    sortHeating (a, b, isAsc) {
      return this.sortStrToNum(
        a.getTotalHeatingConsumption(),
        b.getTotalHeatingConsumption(),
        isAsc
      )
    }
  }
}
</script>

<style>
p.warning {
  color: hsl(348, 100%, 61%);
}
</style>
